import { css, Stack } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext, useState } from 'react'
import { CurrencyContext } from 'components/Hook/CurrencyContext'
import { Button } from 'components/common/Button'
import { SettingsModal } from './SettingsModal'

interface SettingsProps {
  allCurrencies: string[]
}

export const Settings = ({ allCurrencies }: SettingsProps) => {
  const { i18n } = useTranslation(['common', 'home'])

  const currency = useContext(CurrencyContext)
  const [languageChange, setLanguageChange] = useState(false)
  const [isSettingsOpen, setSettingsOpen] = useState(false)

  const openSettings = () => {
    setSettingsOpen(true)
  }
  const closeSettings = () => {
    setSettingsOpen(false)
  }

  return (
    <>
      <SettingsModal
        allCurrencies={allCurrencies}
        isSettingsOpen={isSettingsOpen}
        closeSettings={closeSettings}
        setLanguageChange={setLanguageChange}
      />
      <Stack flexDirection="row" onClick={openSettings}>
        <Button
          disabled={languageChange}
          label={i18n.language.toUpperCase()}
          css={css`
            margin-right: -1px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          `}
        />
        <Button
          disabled={languageChange}
          label={currency.toUpperCase()}
          css={css`
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          `}
        />
      </Stack>
    </>
  )
}
